import { SettingsDTO } from '../../../Domain/DTO/SettingsDTO';
import { BaseEntityPropsInitial, IBaseEntityProps } from '../BaseEntity/IBaseEntityProps';
import { ISettingsHelperProps, SettingsHelperPropsInitial } from './ISettingsHelperProps';

export interface ISettingsProps extends IBaseEntityProps<SettingsDTO, ISettingsHelperProps> {
}

export const SettingsPropsInitial: ISettingsProps = { ...BaseEntityPropsInitial, DataHelper: SettingsHelperPropsInitial };